<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Page-Break" id="_idParaDest-1"><a id="_idTextAnchor000"></a>AUTHOR’S NOTE</p>
<p class="ORIM-Chapter-Opener-Paragraph">The author ventures to take this opportunity to thank his readers for the kind reception they have accorded to the successive editions of this tale during the last twelve years. He hopes that in its present form it will fall into the hands of an even wider public, and that in years to come it may continue to afford amusement to those who are still young enough at heart to love a story of treasure, war, and wild adventure.</p>
<p class="ORIM-Body-Text-Right">Ditchingham,</p>
<p class="ORIM-Body-Text-Right">11 March, 1898.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled12.vue?785cdab3